import { render, staticRenderFns } from "./about_gansu.vue?vue&type=template&id=0e057280&"
import script from "./about_gansu.vue?vue&type=script&lang=js&"
export * from "./about_gansu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports